import { useState } from 'react';
import Checkbox2 from './Checkbox2';

const linkStyle = {
  color: 'var(--color-accent-100)',
  fontWeight: 500,
  textDecoration: 'none'
};

const handleLinkMouseEnter = (e) => {
  e.target.style.textDecoration = 'underline';
};

const handleLinkMouseLeave = (e) => {
  e.target.style.textDecoration = 'none';
};

const FormAgreementLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    style={linkStyle}
    onMouseEnter={handleLinkMouseEnter}
    onMouseLeave={handleLinkMouseLeave}
  >
    {children}
  </a>
);

const FormAgreement = ({ button = 'Отправить', onChange, style }) => {
  const [policyAccepted, setPolicyAccepted] = useState(false);
  const [personalAccepted, setPersonalAccepted] = useState(false);

  const handlePolicyChange = (e) => {
    const checked = e.target.checked;

    setPolicyAccepted(checked);
    if (onChange) onChange(checked && personalAccepted);
  };

  const handlePersonalChange = (e) => {
    const checked = e.target.checked;

    setPersonalAccepted(checked);
    if (onChange) onChange(policyAccepted && checked);
  };

  return (
    <div style={style}>
      <Checkbox2
        checked={policyAccepted}
        onChange={handlePolicyChange}
        style={{ margin: '18px 0 8px' }}
      >
        <span style={{ opacity: 0.8 }}>
          Я ознакомлен и согласен с{' '}
          <FormAgreementLink href="/downloads/personal.pdf">
            Политикой обработки персональных данных
          </FormAgreementLink>{' '}
          и{' '}
          <FormAgreementLink href="/downloads/policy.pdf">
            Политикой конфиденциальности
          </FormAgreementLink>
          .
        </span>
      </Checkbox2>
      <Checkbox2
        checked={personalAccepted}
        onChange={handlePersonalChange}
        style={{ margin: '8px 0 18px' }}
      >
        <span style={{ opacity: 0.8 }}>
          Нажимая кнопку «{button}», я подтверждаю свое{' '}
          <FormAgreementLink href="/downloads/personal-accept.pdf">
            Согласие на обработку персональных данных
          </FormAgreementLink>
          .
        </span>
      </Checkbox2>
    </div>
  );
};

export default FormAgreement;
